import { useMemo, useState, useEffect } from "react";
import { Table } from "rsuite";
import { sortTableData } from "../../utils/tableFilter";
import { ApiSchemaDataExchangeSetting } from "../../models/api/dataExchangeSetting";
import { useAppDispatch, useAppSelector } from "../../core/redux/ReduxStore";
import { useHistory } from "react-router-dom";
import { AppRouteUi } from "../../config/appRoute";
import editIcon from "../../assets/img/edit-icon.svg";
import { Button } from "../../components/button.component";

const { Column, HeaderCell, Cell } = Table;

// Use the API interface and extend it with the sl property for the table
interface TableData extends ApiSchemaDataExchangeSetting {
  sl: number;
}

export const HHAExchangeConfigList = ({
  totalCount,
  data,
  isValidating,
}: {
  totalCount: number;
  data?: ApiSchemaDataExchangeSetting[]; // Now using the updated interface
  isValidating: boolean;
}) => {
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [sortBy, setSortBy] = useState<keyof TableData>("sl");
  const [sortAsc, setSortAsc] = useState(true);
  const history = useHistory();

  const { pageNumber, pageSize } = useAppSelector((state) => state.hhaConfigTable);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data && data.length > 0) {
      setTableData(
        data.map((config, index) => ({
          sl: (pageNumber - 1) * pageSize + index + 1,
          ...config,
        }))
      );
    } else {
      setTableData([]);
    }
  }, [data, pageNumber, pageSize]);

  const sortedTableData = useMemo(() => {
    return sortTableData<TableData>(tableData, sortBy, sortAsc);
  }, [sortAsc, sortBy, tableData]);

  const handleSortColumn = (dataKey: string, sortType?: "asc" | "desc") => {
    setSortBy(dataKey as keyof TableData);
    setSortAsc(sortType === "asc");
  };

  const handleEdit = (rowData: TableData) => {
    history.push(AppRouteUi.HHAConfig.Edit(rowData.companyId));
  };

  const handleAdd = () => {
    history.push(AppRouteUi.HHAConfig.Add());
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div></div>
        <Button
          className="px-4 btn-green"
          name="Add"
          onClick={handleAdd}
        />
      </div>
      <Table 
        data={sortedTableData}
        className="bg-white rs-theme-light rs-table-border-radius-0 rounded-table-8"
        autoHeight
        loading={isValidating}
        bordered
        sortColumn={sortBy.toString()}
        sortType={sortAsc ? "asc" : "desc"}
        onSortColumn={handleSortColumn}
      >
        <Column width={60} align="center" fixed>
          <HeaderCell>#</HeaderCell>
          <Cell>
            {(rowData: TableData) => <div className="lh-lg">{rowData.sl}</div>}
          </Cell>
        </Column>

        <Column width={180} flexGrow={1} sortable>
          <HeaderCell>Company Name</HeaderCell>
          <Cell>
            {(rowData: TableData) => (
              <div className="lh-lg">{rowData.companyName}</div>
            )}
          </Cell>
        </Column>
        
        <Column width={160} flexGrow={1} sortable>
          <HeaderCell>Grant Type</HeaderCell>
          <Cell>
            {(rowData: TableData) => (
              <div className="lh-lg">{rowData.grantType}</div>
            )}
          </Cell>
        </Column>
        <Column width={80} fixed="right">
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData: TableData) => (
              <img
                src={editIcon}
                alt="Edit"
                className="me-1 click"
                height={15}
                onClick={() => handleEdit(rowData)}
              />
            )}
          </Cell>
        </Column>
      </Table>
    </>
  );
};